import React, {useEffect} from 'react'

import {useDispatch, useSelector} from 'react-redux'
import {Navigate, Route} from 'react-router-dom'

import {FullScreenLoading} from '../Components/Common/loader/FullScreenLoading'
import {useProfile} from '../Components/Hooks/UserHooks'
import {setAuthorization} from '../helpers/api_helper'
import {logoutUser} from '../slices/auth/login/thunk'
import {setTokenIsValidated} from '../slices/thunks'

const AuthProtected = props => {
  const dispatch = useDispatch()
  const {userProfile, loading, token} = useProfile()
  const isTokenValidated = useSelector(state => state.Info.isTokenValidated)

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token)
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser())
      dispatch(setTokenIsValidated())
    }
  }, [token, userProfile, loading, dispatch])

  if (!isTokenValidated) {
    return <FullScreenLoading />
  }

  /*
    Navigate is un-auth access protected routes via url
    */

  if (!userProfile && loading && !token) {
    return <Navigate to={{pathname: '/login', state: {from: props.location}}} />
  }

  return <>{props.children}</>
}

const AccessRoute = ({component: Component, ...rest}) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (
          <>
            {' '}
            <Component {...props} />{' '}
          </>
        )
      }}
    />
  )
}

export {AuthProtected, AccessRoute}
